export default __webpack_public_path__ + "static/media/institute-16-min.49a0ff20.webp";